import { render, staticRenderFns } from "./WasteWaterView.vue?vue&type=template&id=c62323ca&"
import script from "./WasteWaterView.vue?vue&type=script&lang=js&"
export * from "./WasteWaterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports